const ACTIONS = {
    SPEC_CURRENT_REQUEST_SUCCESS: "SPEC_CURRENT_REQUEST_SUCCESS",
    SET_SPEC_NEED_REFRESH: "SET_SPEC_NEED_REFRESH",
    SET_SPEC_COMMENT_FORM_STATE: "SET_SPEC_COMMENT_FORM_STATE",
    DELETE_SPEC_COMMENT_FORM_STATE: "DELETE_SPEC_COMMENT_FORM_STATE",
};

const initialState = {
    service: {
        currentData: {},
        isNeedRefresh: false,
        commentFormState: {},
    },
    resource: {
        currentData: {},
        isNeedRefresh: false,
        commentFormState: {},
    },
    document: {
        currentData: {},
        isNeedRefresh: false,
        commentFormState: {},
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.SPEC_CURRENT_REQUEST_SUCCESS: {
            return { ...state, [action.specType]: { ...state[action.specType], currentData: action.result } };
        }

        case ACTIONS.SET_SPEC_NEED_REFRESH: {
            return { ...state, [action.specType]: { ...state[action.specType], isNeedRefresh: action.isNeedRefresh } };
        }

        case ACTIONS.SET_SPEC_COMMENT_FORM_STATE: {
            const { commentFormState, id } = action;
            return {
                ...state,
                [action.specType]: {
                    ...state[action.specType],
                    commentFormState: { ...state[action.specType].commentFormState, [id]: commentFormState },
                },
            };
        }
        case ACTIONS.DELETE_SPEC_COMMENT_FORM_STATE: {
            const { id } = action;
            delete state[action.specType].commentFormState[id];
            return state;
        }

        default: {
            return state;
        }
    }
};

export const setCurrentData = (specType, result) => ({
    type: ACTIONS.SPEC_CURRENT_REQUEST_SUCCESS,
    specType,
    result,
});

export const setSpecNeedRefresh = (specType, isNeedRefresh) => ({
    type: ACTIONS.SET_SPEC_NEED_REFRESH,
    specType,
    isNeedRefresh,
});

export const setSpecCommentFormState = (specType, specId, commentFormState) => ({
    type: ACTIONS.SET_SPEC_COMMENT_FORM_STATE,
    specType,
    id: specId,
    commentFormState,
});

export const deleteSpecCommentFormState = (specType, specId) => ({
    type: ACTIONS.DELETE_SPEC_COMMENT_FORM_STATE,
    specType,
    id: specId,
});
